import { isNil } from 'ramda'
import urlParse from 'url-parse'

const isNilOrEmptyString = (value) => isNil(value) || value === ''

export const findMissingFields = ({ requiredPropertyNames, objectToValidate }) => {
  return requiredPropertyNames.filter(requiredPropertyName => isNilOrEmptyString(objectToValidate[requiredPropertyName]))
}

export const prependHTTPSAlways = (url) => {
  const parsedUrl = urlParse(url, {})
  parsedUrl.protocol = 'https:'
  parsedUrl.slashes = true
  if (parsedUrl.href === 'https:/') 
    parsedUrl.pathname = ''

  return parsedUrl.toString()
}
